import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../../components/Header";

function ViewInvoice() {
  const { id } = useParams();
  const [invoiceDetails, setInvoiceDetails] = useState({
    id: "",
    clientName: "",
    email: "",
    invoicenumber: "",
    address: "",
    organizationName: "",
    date: "",
    totalPrice: "",
    phoneNumber: "",
    createdAt: "",
    updatedAt: "",
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchInvoiceDetails();
  }, [id]);

  const fetchInvoiceDetails = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `https://backend.jcgn.org/invoiceform/getInvoiceformById/${id}`
      );
      const responseData = await response.json();
      
      if (responseData.status) {
        // Format the data from the API response
        const result = responseData.result;
        const formattedData = {
          id: result.id || "",
          clientName: result.clientName || "",
          email: result.email || "",
          invoicenumber: result.invoicenumber || "",
          address: result.address || "",
          organizationName: result.organizationName || "",
          date: result.date || "",
          totalPrice: result.totalPrice || "",
          phoneNumber: result.phoneNumber || "",
          createdAt: result.createdAt ? new Date(result.createdAt).toLocaleDateString() : "",
          updatedAt: result.updatedAt ? new Date(result.updatedAt).toLocaleDateString() : "",
        };
        
        setInvoiceDetails(formattedData);
      } else {
        setError("Failed to fetch invoice details: " + responseData.message);
        console.error("Failed to fetch invoice details:", responseData.message);
      }
    } catch (error) {
      setError("Error fetching invoice details");
      console.error("Error fetching invoice details:", error);
    } finally {
      setLoading(false);
    }
  };

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  if (loading) return <Typography>Loading invoice details...</Typography>;
  if (error) return <Typography color="error">{error}</Typography>;

  return (
    <Box m="20px" height="70vh" overflow="auto" paddingRight="20px">
      <Header title={`View Invoice ID: ${id}`} subtitle="" />
      <Box ml={"40px"}>
        <Grid container spacing={2}>
          {Object.entries(invoiceDetails).map(([field, value]) => (
            <React.Fragment key={field}>
              <Grid item xs={2.5}>
                <Typography variant="h6" component="span" fontWeight="bold">
                  {capitalizeFirstLetter(field)}
                </Typography>
              </Grid>
              <Grid item xs={1}>
                <Typography variant="h6" component="span" fontWeight="bold">
                  :
                </Typography>
              </Grid>
              <Grid item xs={8.5}>
                <Typography>{value || "N/A"}</Typography>
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}

export default ViewInvoice;